import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useModal } from 'react-modal-hook'
import authServices from '../../../services/auth.service'
import { Formik, Form } from 'formik'
import Modal from '../../../components/Modal/Modal'
import CheckMarkIcon from 'custom/assets/icons/requests/709510'
import InputError from '../../../components/InputError/InputError'
import Loading from 'custom/assets/loaders/Loading'
import '../Auth.css'
import './ForgotPassword.css'
import NeoInput from '../../../components/NeoInput/NeoInput'
import NeoButton from '../../../components/NeoButton/NeoButton'
import AuthLayout from '../auth-layout'
import { ForgotPasswordSchema } from '../../../schemas/auth'
import { encryptAES } from '../../../services/auth.service'
import {
  FORGOT_PASSWORD_KEYS,
  BUTTON_KEYS,
  VALIDATION_KEYS,
} from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
const forgotPasswordConfig = validationConfig['forgotPassword']
import * as Yup from 'yup'

export default function ForgotPassword() {
  const history = useHistory()
  const [message, setMessage] = useState('Something went wrong.Please contact bank!')
  const defaultErrorMessage = 'Something went worng. Please contact Bank'
  const [loading, setLoading] = useState(false)
  const [criteriaList, setCriteriaList] = useState([])
  const [captch, setCaptch] = useState()
  const [passwordPattern, setPasswordPattern] = useState(null)
  const [passwordLength, setPasswordLength] = useState()
  const [formValues, setFormValues] = useState({})
  const [verifyDetails, setVerifyDetails] = useState()
  const [type, setType] = useState(1)
  const { t } = useTranslation()
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6 className='text-center'>{message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
                setType(1)
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(() => {
    const forgetPwdCriteria = async () => {
      // setLoading(true)
      try {
        const response = await authServices.forgetPwdCriteria({})
        if (response.status === 200) {
          setCriteriaList(response.data['userPasswordCriteriaMap'])
          // const pwdMaxLength = response.data['userPasswordCriteria'][3].value
          // const pwdMinLength = response.data['userPasswordCriteria'][4].value
          // const pwdMinAlphabetLength = response.data['userPasswordCriteria'][0].value
          // const pwdMinNumberLength = response.data['userPasswordCriteria'][1].value
          // const pwdMinSplCharLength = response.data['userPasswordCriteria'][2].value
          const pwdMaxLength = response.data['userPasswordCriteriaMap']['MAX_PWD_LENGTH']
          const pwdMinLength = response.data['userPasswordCriteriaMap']['MIN_PWD_LENGTH']
          const pwdMinAlphabetLength = response.data['userPasswordCriteriaMap']['ALPHABETS']
          const pwdMinNumberLength = response.data['userPasswordCriteriaMap']['NUMERICS']
          const pwdMinSplCharLength = response.data['userPasswordCriteriaMap']['SPECIAL_CHARACTERS']
          const pattern = `(?=^.{${pwdMinLength},${pwdMaxLength}}$)(?=(.*\\d){${pwdMinNumberLength}})(?=(.*[A-Za-z]){${pwdMinAlphabetLength}})(?=(.*[\\+\\- \\= \\[\\]\\{ \\}\\;\\-\\(\\)\\<\\>\\_'!@#$%^&*?\"|/,.:\`~\\\\]){${pwdMinSplCharLength}})(?!.*[\\s])^.*`
          setPasswordPattern(pattern)
          setPasswordLength(pwdMaxLength)
          // setLoading(false)
        }
      } catch (err) {
        // setLoading(false)
        //setMessage(err.data.message)
        // //showModal()
      }
    }
    forgetPwdCriteria()
  }, [])

  const forgetPwdVerify = useCallback(
    async (values, { setSubmitting }) => {
      try {
        setSubmitting(true)
        setLoading(true)
        const reqParams = {
          ...values,
        }
        const response = await authServices.forgetPwdVerify(reqParams)
        if (response.status === 200) {
          setFormValues(values)
          setVerifyDetails(response.data)
          //setCaptch(response.data.captchaCode)
          setSubmitting(false)
          setLoading(false)
          setType(2)
        }
      } catch (err) {
        // setMessage(err.data.message)
        setLoading(false)
        setSubmitting(false)
        // //showModal()
      }
    },
    [showModal],
  )

  const forgetPwdConfirm = useCallback(
    async (values, { setSubmitting }) => {
      try {
        setSubmitting(true)
        console.log(formValues)
        const reqParams = {
          ...values,
          userName: formValues.userName,
          dob: formValues.dob,
          phoneNo: formValues.phoneNo,
          randomKey: verifyDetails?.randomKey,
          password: encryptAES(values.newPassword),
          captcha: encryptAES(values.captchaCode),
        }
        const response = await authServices.forgetPwdConfirm(reqParams)
        if (response.status === 200) {
          // history.push('/login')
          setMessage(response.data.message)
          setSubmitting(false)
          setType(3)
        }
      } catch (err) {
        // setMessage(err.data.message)
        setSubmitting(false)
        // //showModal()
      }
    },
    [showModal, verifyDetails, formValues],
  )

  function renderSwitch() {
    switch (type) {
      case 1:
        return forgetPasswordVerify()
      case 2:
        return forgetPasswordReset()
      case 3:
        return renderSuccess()
      default:
        return forgetPasswordVerify()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function handleKeyDown(e) {
    if (e.key === ' ') {
      e.preventDefault()
    }
  }

  function renderSuccess() {
    return (
      <div>
        <div className='text-center' style={{ paddingBottom: 100 }}>
          <CheckMarkIcon />
          <h5 className='mt-5'>{message}</h5>

          <div className='mt-4 mx-auto px-0 col-3'>
            <NeoButton
              tabIndex='1'
              type='button'
              mode='newDesign'
              text={t(BUTTON_KEYS.DONE)}
              onClick={() => {
                history.push('/login')
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  function forgetPasswordVerify() {
    return (
      <div>
        <Formik
          enableReinitialize
          onSubmit={forgetPwdVerify}
          validationSchema={ForgotPasswordSchema}
          initialValues={{ userName: '', dob: '', phoneNo: '' }}>
          {({ isSubmitting, errors, touched, setFieldValue, handleChange, values }) => (
            <Form>
              <div className='form-group  my-3'>
                <NeoInput
                  tabIndex='1'
                  showAsterisk={forgotPasswordConfig['isUserNameRequired']}
                  name='userName'
                  onChange={handleChange}
                  text={t(FORGOT_PASSWORD_KEYS.USERNAME)}
                  mode='single'
                  icon='person'
                  placeholder={t(FORGOT_PASSWORD_KEYS.USERNAME)}
                  value={values.username}
                />
                <InputError text={errors.userName} touched={touched.userName} />
              </div>

              <div className='form-group  my-3'>
                <NeoInput
                  tabIndex='2'
                  showAsterisk={forgotPasswordConfig['isPhoneNoRequired']}
                  name='phoneNo'
                  onChange={(value) => {
                    setFieldValue('phoneNo', value?.value)
                  }}
                  // onChange={handleChange}
                  text={t(FORGOT_PASSWORD_KEYS.MOBILE_NO)}
                  mode='onlyNumber'
                  icon='phone'
                  placeholder={t(FORGOT_PASSWORD_KEYS.MOBILE_NO)}
                  value={values.phoneNo}
                />
                <InputError text={errors.phoneNo} touched={touched.phoneNo} />
              </div>
              <div className='form-group  my-3'>
                <NeoInput
                  tabIndex='3'
                  showAsterisk={forgotPasswordConfig['isDOBRequired']}
                  name='dob'
                  onChange={handleChange}
                  text={t(FORGOT_PASSWORD_KEYS.DOB)}
                  type='date'
                  max={(function () {
                    const today = new Date()
                    const dd = today.getDate()
                    const mm = today.getMonth() + 1
                    const yyyy = today.getFullYear() - 18
                    return `${yyyy}-${mm < 10 ? '0' + mm : mm}-${dd < 10 ? '0' + dd : dd}`
                  })()}
                  mode='single'
                  icon='person'
                  value={values.dob}
                />
                <InputError text={errors.dob} touched={touched.dob} />
              </div>

              <div className='mt-5' />
              {isSubmitting === false && loading === false ? (
                <NeoButton
                  tabIndex='4'
                  text={t(BUTTON_KEYS.SUBMIT)}
                  mode='newDesign'
                  disabled={isSubmitting}
                  type='submit'
                />
              ) : (
                renderLoading()
              )}
              <div className='my-3'>
                <button
                  tabIndex='5'
                  onClick={() => {
                    history.push('/login')
                  }}
                  className='btn btn-sm btn-link small new-design-warning-text-color font-weight-600'
                  style={{ marginLeft: '160px' }}>
                  {t(BUTTON_KEYS.LOGIN)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  const ForgotPasswordConfirmSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required(VALIDATION_KEYS.NEW_PASSWORD_REQUIRED)
      .matches(new RegExp(passwordPattern), VALIDATION_KEYS.PASSWORD_MATCH_CRITERIA),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], VALIDATION_KEYS.PASSWORD_MATCH)
      .required(VALIDATION_KEYS.CONFIRM_PASSWORD_REQUIRED),
    captchaCode: Yup.string().required(VALIDATION_KEYS.CAPCHA),
    otp: Yup.string()
      .matches(new RegExp('^[0-9]{4}$'), VALIDATION_KEYS.VALIDATE_OTP)
      .required(VALIDATION_KEYS.OTP_REQUIRED),
  })

  function forgetPasswordReset() {
    return (
      <div>
        <Formik
          enableReinitialize
          onSubmit={forgetPwdConfirm}
          validationSchema={ForgotPasswordConfirmSchema}
          initialValues={{ newPassword: '', confirmNewPassword: '', otp: '', captchaCode: '' }}>
          {({ isSubmitting, errors, touched, setFieldValue, handleChange, values }) => (
            <Form>
              <div className='form-group  my-3'>
                <NeoInput
                  tabIndex='1'
                  showAsterisk={forgotPasswordConfig['isNewPasswordRequired']}
                  name='newPassword'
                  onChange={handleChange}
                  text={t(FORGOT_PASSWORD_KEYS.NEW_PASSWORD)}
                  mode='sensitiveIcon'
                  type='password'
                  onKeyDown={handleKeyDown}
                  disabled={isSubmitting}
                  maxLength={passwordLength}
                />
                <InputError text={errors.newPassword} touched={touched.newPassword} />
              </div>
              <div className='form-group  my-3'>
                <NeoInput
                  tabIndex='2'
                  showAsterisk={forgotPasswordConfig['isConfirmPasswordRequired']}
                  name='confirmNewPassword'
                  onChange={handleChange}
                  text={t(FORGOT_PASSWORD_KEYS.CONFIRM_PASSWORD)}
                  mode='sensitiveIcon'
                  type='password'
                  disabled={isSubmitting}
                  maxLength={passwordLength}
                />
                <InputError text={errors.confirmNewPassword} touched={touched.confirmNewPassword} />
              </div>
              <div>
                {t(FORGOT_PASSWORD_KEYS.CAPCHA)} :{' '}
                {/* <i style={{ fontSize: 16, fontWeight: 500 }}>{verifyDetails?.captchaCode}</i> */}
                <img src={`data:image/png;base64, ${verifyDetails?.captchaCode}`} height='50'/>
              </div>

              <div className='form-group my-3'>
                <NeoInput
                  tabIndex='3'
                  text={t(FORGOT_PASSWORD_KEYS.CAPCHA)}
                  showAsterisk={forgotPasswordConfig['isCapchaRequired']}
                  onChange={handleChange}
                  name='captchaCode'
                  disabled={isSubmitting}
                />
                <InputError text={errors.captchaCode} touched={touched.captchaCode} />
              </div>

              <div className='form-group my-3'>
                <NeoInput
                  tabIndex='4'
                  showAsterisk={forgotPasswordConfig['isOTPRequired']}
                  maxLength={4}
                  text={t(FORGOT_PASSWORD_KEYS.OTP)}
                  type='number'
                  mode='onlyNumber'
                  onChange={(value) => {
                    setFieldValue('otp', value?.value)
                  }}
                  name='otp'
                  disabled={isSubmitting}
                />
                <InputError text={errors.otp} touched={touched.otp} />
              </div>

              <div className='passwordCriteria'>
                <h6>{t(FORGOT_PASSWORD_KEYS.PASSWORD_CRITERIA)}</h6>
                {/* {criteriaList.map((value, i) => (
                  <p key={i} className='card-text col'>
                    {value.description} : <b>{value.value}</b>
                  </p>
                ))} */}
                {Object.keys(criteriaList).map((key, i) => (
                        <p key={i} className='card-text col'>
                          {t(key)} : <b>{criteriaList[key]}</b>
                        </p>
                      ))}
              </div>
              <div className='mt-5' />
              {isSubmitting === false && loading === false ? (
                <NeoButton
                  tabIndex='6'
                  text={t(BUTTON_KEYS.SUBMIT)}
                  mode='newDesign'
                  disabled={isSubmitting}
                  type='submit'
                />
              ) : (
                renderLoading()
              )}
              <div className='my-3'>
                <button
                  tabIndex='7'
                  onClick={() => {
                    setType(1)
                  }}
                  className='btn btn-sm btn-link small new-design-warning-text-color font-weight-600'
                  style={{ marginLeft: '160px' }}>
                  {t(BUTTON_KEYS.BACK)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  return (
    <AuthLayout>
      <div className='container col ' style={{ width: '400px' }}>
        <h3 className='register-with-us-tod'>{t(FORGOT_PASSWORD_KEYS.FORGOT_PASSWORD)}</h3>
        <div className='my-4' />
        {renderSwitch()}
      </div>
    </AuthLayout>
  )
}
